import { defineComponent as _defineComponent } from 'vue'
import RegisteredProducts from './Settings/registered_products.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'Settings',
  setup(__props, { expose: __expose }) {
  __expose();

    
const __returned__ = { RegisteredProducts }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})